import { createFileRoute } from "@tanstack/react-router"
import DailyReportSettings from "@/app/report/daily/settings/page"

export const Route = createFileRoute("/settings/report/daily")({
  component: DailyReportSettings,
})
